import { z } from 'zod/v4';
import { TemplateSchema } from './attachment-template.js';

export const TemplateDocumentSchema = z.object({
  id: z.string(),
  documentType: z.string(),
  documentClass: z.enum(['TRANSACTIONAL', 'COMPANY', 'PRODUCT']),
  title: z.string().nullable(),
  isMandatory: z.boolean(),
  isAppliedToAllCountries: z.boolean(),
  idx: z.number().int(),
  countryCodes: z.array(z.string()),
});

export const TemplateRuleSchema = z.object({
  id: z.string(),
  idx: z.number().int(),
  isBackupRule: z.boolean(),
  facilityProcesses: z.array(
    z.object({ id: z.string(), name: z.string().nullable() }),
  ),
  documents: z.array(TemplateDocumentSchema),
});

export const TemplateDetailsSchema = TemplateSchema.extend({
  rules: z.array(TemplateRuleSchema),
  backupRule: TemplateRuleSchema.nullable(),
  hasOrders: z.boolean(),
});

export type TemplateDetailsType = z.infer<typeof TemplateDetailsSchema>;
